const en_indo5 = {
    common: {
        distributor: "distributor",
        employee: 'employee',
        ktp: 'KTP',
        zip: 'post code',
        region: 'region',
        customer: 'outlet',
        chain: 'chain',
        channel: 'channel',
        account_name: 'account name',
        account_number: 'account number',
        project: 'project',
        project_admin: 'project admin',
        sales: 'sales',
        verified: 'verified',
    },
    menu: {
        so: "sales order (SO)",
        do: "delivery order (DO)",
        distributor: "distributor",
        sales: "employee",
        customer: "outlet",
        assignment: 'assignment',
        region: 'region',
        chain: 'chain',
        channel: 'channel',
        employee_type: 'employee type',
        project: 'project',
        project_list: 'project list',
        form_builder: 'form builder',
    },
    distributor: {
        "add": "add distributor",
        "edit": "edit distributor",
        "name": "distributor name",
        "pic": "PIC warehouse distributor",
        "phone": "distributor phone",
        "fax": "distributor fax",
        "email": "distributor email",
    },
    so: {
        "detail": "sales order (SO) detail",
        "update_sales": "update SO sales",
    },
    do: {
        "detail": "delivery order (DO) detail"
    },
    sales: {
        "add": "add employee",
        "edit": "edit employee",
        "name": "employee name",
        "phone": "employee phone",
        "email": "employee email",
        "connection": "outlet connection",
        "add_connection": "add outlet connection",
        "delete_connection": "delete outlet connection",
    },
    assignmentsales: {
        "": "visit schedule",
        "schedule": "visit schedule list",
        "edit_schedule": "edit visit schedule",
    },
    assignmentgoods: {
        "": "goods assignment",
        "list": "list goods assignment",
        "edit": "edit list goods assignment",
    },
    customer: {
        "add": "add outlet",
        "edit": "edit outlet",
        "name": "outlet name",
        "phone": "outlet phone",
        "email": "outlet email",
        "btype": "business type",
        "distance": "max distance (meter)",
        "save_noo": "save and validate"
    },
    region: {
        "add": "add region",
        "edit": "edit region",
        "name": "region name",
        "parent": "region parent",
        "search_name": "Search Region Name",
    },
    chain: {
        "add": "add chain",
        "edit": "edit chain",
        "name": "chain name",
        "parent": "chain parent",
        "search_name": "Search Chain Name",
    },
    channel: {
        "add": "add channel",
        "edit": "edit channel",
        "name": "channel name",
        "parent": "channel parent",
        "search_name": "Search Channel Name",
    },
    employee_type: {
        "add": "add employee type",
        "edit": "edit employee type",
        "name": "type name",
        "search_name": "Search Type Name",
    },
    project_list: {
        "name": "project name",
        "date": "project date",
        "date_new_end_date": "new project end date",
        'add': "add project",
        'edit': "edit project",
        "extend": "extend project",
        'view': "detail project",
        "distributor": "list of project distributors",
        "add_distributor": "add distributor",
        "edit_distributor": "edit distributor",
        "delete_distributor": "delete distributor",
        "sku": "SKU project list",
        "add_sku": "add SKU",
        "edit_sku": "edit SKU",
        "delete_sku": "delete SKU",
        "customer": "list of project outlet connections",
        "edit_customer": "edit outlet connection",
        "sales_visit": "list of project sales visits",
        "sales_visit_upload": "upload sales visit schedule",
        "add_area": "add region | channel | chain",
    },
    form_builder: {
        "name": "form name",
        'add': "add form",
        'edit': "edit form",
        'add_field': 'add field',
        'field_name': 'field name',
        'field_note': 'field name',
        'form_type': 'form type',
        'sales_type': 'employee type',
        'init_value': 'initial value / text',
        'add_option': 'add option',
        'add_sku': 'add SKU',
        'add_all_sku': 'add all SKU',
        'list_option': 'option list',
    },
}

export default en_indo5;